/**
 * Homepage Cache Strategy
 * Cache strategy for homepage game sections
 */

import { BaseCacheStrategy } from './baseCacheStrategy'

export class HomepageCacheStrategy extends BaseCacheStrategy {
  /**
   * Get or set homepage section data
   * @param {string} section - Section name (bonusGames, newGames, etc.)
   * @param {*} data - Data to set (optional)
   * @returns {*} Cached data if getting, undefined if setting
   */
  static handleSection(section, data = null) {
    const sectionStrategy = new BaseCacheStrategy(section)

    if (data !== null) {
      sectionStrategy.set(data)
      return undefined
    }

    return sectionStrategy.get()
  }

  /**
   * Get countdown for specific section
   * @param {string} section - Section name
   * @returns {Object|null} Countdown info
   */
  static getSectionCountdown(section) {
    const sectionStrategy = new BaseCacheStrategy(section)
    return sectionStrategy.getCountdown()
  }

  /**
   * Check if section cache is valid
   * @param {string} section - Section name
   * @returns {boolean} True if valid
   */
  static isSectionValid(section) {
    const sectionStrategy = new BaseCacheStrategy(section)
    return sectionStrategy.isValid()
  }
}

export default HomepageCacheStrategy
